export const environment = {
  production: true,
  apiBaseUrl: 'https://rd.vigimare.simavi.ro/vigimare/api',
};
